const STATUS = {
  OK: 200,
  NO_CONTENT: 204,
  SERVER_ERROR: 500,
  FORBIDDEN: 403,
  UNAUTHERIZIED: 401,
};

export const NOTIFI_TYPE = {
  BUY: 0,
  SALE: 1,
  BID_MADE: 2,
  BID_RECEIVED: 3,
  OFFER_MADE: 4,
  OFFER_RECEIVED: 5
}

export const METHOD_TYPE = {
  DIRECT_SALE: 0,
  AUCTION: 1,
  UNLISTED: 2
}

export const COLLECTION_TYPE = {
  CATALOG: 0,
  FOR_SALE: 1
}

export default STATUS;
